module.exports = __webpack_public_path__ + "static/media/03.c95ef46b.mp3";